import { isDRMEnabled } from '@jwplayer/companion/drm';
import { queryCache } from 'react-query';

import { useQuery } from '/module/query';

const getQueryKey = (siteId: string) => ['site-drm-enabled', siteId];

export async function hydrateQueryCache(siteId: string) {
  await queryCache.prefetchQuery(getQueryKey(siteId), ({ signal }) => retrieve(siteId, signal));
}

const retrieve = async (siteId: string, signal?: AbortController['signal']) =>
  (
    await isDRMEnabled({
      siteId,
      signal,
    })
  ).content.is_enabled;

export function useSiteDrmEnabled(siteId: string): boolean {
  const drmEnabledQuery = useQuery(getQueryKey(siteId), ({ signal }) => retrieve(siteId, signal), {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    forceFetchOnMount: false,
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  });

  return typeof drmEnabledQuery.data === 'boolean' ? drmEnabledQuery.data : false;
}
